import {
    Text,
    View,
    StyleSheet,
} from '@react-pdf/renderer';
import { REPORT_SENSOR_REGISTRY } from 'constant/report';
import { ReportItemType, ReportPDFFilterItems } from "types/Reports";

const filterDetailStyles = StyleSheet.create({
    firstContainer: {
        marginTop: 15,
        position: 'relative',
    },
    container: {
        marginTop: 20,
        position: 'relative',
    },
    title: {
        fontFamily: 'Roboto',
        fontSize: 10,
        fontWeight: 500,
        color: '#333333',
    },
    total: {
        marginTop: 8,
        fontFamily: 'Roboto',
        fontSize: 10,
        fontWeight: 500,
        color: '#636363',
    },
    list: {
        marginTop: 8,
        fontFamily: 'Roboto',
        fontSize: 10,
        color: '#636363',
    },
});

type ReportPDFFilterDetailProps = {
    filterItems: ReportPDFFilterItems;
}

export default function ReportPDFFilterDetail({
    filterItems,
}: Readonly<ReportPDFFilterDetailProps>) {
    const types = (Object.keys(filterItems) as ReportItemType[]);

    const list: JSX.Element[] = [];

    const validTypes = types.filter((type) => filterItems[type].length !== 0);

    for (let i = 0; i < validTypes.length; i++) {
        const type = validTypes[i];

        const names = filterItems[type].map((item) => item.name).join(', ');

        list.push(<View style={i === 0 ? filterDetailStyles.firstContainer : filterDetailStyles.container} key={`report-filter-detail-${type}`}>
            <Text style={filterDetailStyles.title}>{` ${i + 1}. ${REPORT_SENSOR_REGISTRY[type].pdfFilterDetailTitle}`}</Text>
            <Text style={filterDetailStyles.total}>{`${REPORT_SENSOR_REGISTRY[type].pdfFilterDetailTotal}: ${filterItems[type].length}`}</Text>
            <Text style={filterDetailStyles.list}>{names}</Text>
        </View>);
    }

    return <>{list}</>
}
